import React from "react";

const Logo = ({
  width = 24,
  height = 24,
}: {
  width?: number;
  height?: number;
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3 22V12C3 10.1144 3 9.17157 3.58579 8.58579C4.17157 8 5.11438 8 7 8C8.88562 8 9.82843 8 10.4142 8.58579C11 9.17157 11 10.1144 11 12"
        stroke="#133345"
        strokeWidth="1.5"
      />
      <path
        d="M17 22V16C17 14.1144 17 13.1716 16.4142 12.5858C15.8284 12 14.8856 12 13 12H11C9.11438 12 8.17157 12 7.58579 12.5858C7 13.1716 7 14.1144 7 16V22"
        stroke="#133345"
        strokeWidth="1.5"
      />
      <path
        d="M21 22.0003V7.77231C21 6.43147 21 5.76105 20.6439 5.24712C20.2877 4.7332 19.66 4.4978 18.4045 4.027C15.9492 3.10628 14.7216 2.64592 13.8608 3.24246C13 3.839 13 5.15011 13 7.77231V12.0003"
        stroke="#133345"
        strokeWidth="1.5"
      />
      <path
        d="M4 8V6.5C4 5.55719 4 5.08579 4.29289 4.79289C4.58579 4.5 5.05719 4.5 6 4.5H8C8.94281 4.5 9.41421 4.5 9.70711 4.79289C10 5.08579 10 5.55719 10 6.5V8"
        stroke="#133345"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M7 4V2"
        stroke="#133345"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M22 22L2 22"
        stroke="#133345"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M10 15H14"
        stroke="#133345"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M10 18H14"
        stroke="#133345"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default Logo;
